<template>
  <div class="container h-100" v-loading="loading">
    <div class="d-flex justify-content-center align-items-center h-100">
      <div class="base-screen">
        <b-card class="form-screen">
          <div class="text-center">
            <router-link :to="{name:'login'}"><img src="../assets/styles/img/logo-large.png" alt="Image placeholder" class="logo-img" /></router-link>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="error-message text-center">
                <p class="mb-4">{{lang.label.notRegistered}}</p>
                <div class="row">
                  <div class="col-12">
                    <h4 class="mt-0  mb-3">{{lang.label.contactDetail}}</h4>
                  </div>
                  <div class="col-12 col-md-12">
                    <label>
                      <a href="tel:+91792517373" class="theme-text">{{details.phone}}</a>
                    </label>
                  </div>
                  <div class="col-12 col-md-12">
                    <label>
                      <a :href="'mailto:'+details.email" class="theme-text">{{details.email}}</a>
                    </label>
                  </div>
                </div>
                <div class="mt-2">
                  <b-btn variant="primary" class="mr-3 w-100" @click="previousRoute">{{lang.label.button.back}}
                  </b-btn>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: 'ContactDetails',
  props: {
    msg: String
  },
  computed: {
    ...mapGetters({
      loading: "loading",
    }),
    mobileNumber(){
      return this.models.mobileNumber;
    }
  },
  data() {
    return {
      lang: this.$lang.contactDetails,
      details: {
        email: '',
        phone:'',
      }
    };
  },
  mounted(){
    this.$store.dispatch('contactDetails').then(value => {
      if(value.data){
        this.details = value.data;
      }
    });
  },
  methods: {
      previousRoute(){
          return this.$router.push({name: 'login'});
      }
      
  }
  
}
</script>

